import type { Content } from '@tiptap/react';

export const Wikitags = [
   'Areaindex',
   'Attribution',
   'Banner',
   'Clearer',
   'Code',
   'Comment',
   'Defineflag',
   'Delete',
   'Delimiters',
   'Document',
   'Embed',
   'Emphasis',
   'Flag',
   'Guidelink',
   'Guidelist',
   'Heading',
   'Hidesubcategories',
   'Image',
   'Implicitlink',
   'Info',
   'Inlinemarkup',
   'Insert',
   'Linebreak',
   'Link',
   'List',
   'Mailto',
   'Mature',
   'Mention',
   'Paragraph',
   'Postimage',
   'Postlink',
   'Prefilter',
   'Quote',
   'Raw',
   'Redirect',
   'Remotecontent',
   'Repairability',
   'Strong',
   'Subscript',
   'Summary',
   'Summaryimage',
   'Superscript',
   'Inlinetable',
   'Suppliers',
   'Table',
   'Teletype',
   'Title',
   'Toc',
   'Transform',
   'Unbalancedtags',
   'Url',
   'Video',
   'Wikilink',
   'Wikilist',
] as const;

export type Wikitag = (typeof Wikitags)[number];

export interface CharacterCountConfig {
   minCharacters?: number;
   maxCharacters?: number;
}

export interface EditorConfig {
   editorId: string;
   wikitags: Wikitag[];
   content?: Content;
   characterCountConfig?: CharacterCountConfig;
   submitHandler?: () => void;
   fallbackHandler?: (err: Error) => void;
   exclude?: Wikitag[];
}
